import { render, staticRenderFns } from "./callStatistics.vue?vue&type=template&id=b52a7980&scoped=true&"
import script from "./callStatistics.vue?vue&type=script&lang=js&"
export * from "./callStatistics.vue?vue&type=script&lang=js&"
import style0 from "./callStatistics.vue?vue&type=style&index=0&id=b52a7980&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52a7980",
  null
  
)

export default component.exports